export default {
    methods: {
        async saveStatistics(segmentId) {
            let request = {};

            if (!this.selectedStatistics) {
                return;
            }

            /**
             * Convert the selectedStatistics into the format the database requires
             */
            const payload = this.selectedStatistics.map((statistic) => {
                let item;
                switch (statistic.type) {
                    case "SegmentCount":
                        item = {
                            type_id: 5,
                            related_id: "id",
                            aggregate: "count",
                            label: statistic.label,
                            aggregate: "count",
                        };
                        break;
                    case "SegmentMetric":
                        item = {
                            type_id: 2,
                            related_id: statistic.metricId,
                            aggregate: statistic.aggregate || "avg",
                            label: statistic.label,
                        };
                        break;
                    case "SegmentNps":
                        item = {
                            type_id: 6,
                            related_id: "nps",
                            label: statistic.label,
                            aggregate: "avg",
                        };
                        break;
                    case "SegmentScore":
                        item = {
                            type_id: 7,
                            related_id: "score",
                            aggregate: statistic.aggregate || "avg",
                            label: statistic.label,
                        };
                        break;
                    case "SegmentScoreSet":
                        item = {
                            type_id: 3,
                            related_id: statistic.scoreSetId,
                            aggregate: statistic.aggregate || "avg",
                            label: statistic.label,
                        };
                        break;
                    case "SegmentTrait":
                        item = {
                            type_id: 4,
                            related_id: statistic.property,
                            aggregate: statistic.aggregate || "avg",
                            data_type_id: statistic.dataTypeId,
                            transformation_type_id:
                                statistic.transformationTypeId,
                            label: statistic.label,
                        };
                        break;
                }
                return item;
            });

            const response = await this.segmentsRepository
                .statistics(segmentId)
                .set(payload, request);
        },
    },
};
